<script setup lang="ts">
const siteUrl = useSiteUrl()
</script>

<template>
    <!-- start login  -->
    <section class="bg-[#FFBF00] w-full">

        <div class="w-full grid lg:grid-cols-2 items-center">
            <div
                class="w-full h-[212px] lg:h-full bg-[#FFBF00] flex flex-col items-center lg:items-start justify-center pb-6 pt-10 lg:pb-0 lg:ps-24">
                <!-- <div class="text-[24px] lg:text-[40px] text-center lg:text-right font-semibold text-[#2E2EE5]">
                تبادل ارز <span class="font-black text-[24px] lg:text-[47px]">به صرفه و <span class="block"><br></span> ایمن</span> را با ما شروع کنید
            </div> -->
                <h2
                    class="flex flex-col items-center  lg:items-start text-[24px] lg:text-[40px] font-medium text-[#2E2EE5]">
                    <span class="flex items-center gap-2">
                        <span>تبادل ارز</span>
                        <span class="font-black text-[24px] lg:text-[47px]">به صرفه</span>
                    </span>
                    <span class="flex items-center gap-2">
                        <span class="font-black text-[24px] lg:text-[47px]">و ایمن</span>
                        <span>را با ما شروع کنید</span>
                    </span>
                </h2>
                <UiButton id="login-btn3" :href="siteUrl('/auth/register')"
                    class="mt-8 bg-[#2E2EE5] w-[128px] h-[41px] lg:w-[167px] lg:h-[61px] lg:text-xl font-bold"
                    :link="true" :rounded="true" :external="true">
                    شروع ثبت نام
                </UiButton>
            </div>
            <div class="w-full h-auto bg-gray-200">
                <img class="w-full h-full" src="/home/img/home/CurrencyExchange.png" alt="تبادل ارز در پی‌جیب">
            </div>
        </div>

    </section>
</template>
